import React from "react";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Grid from "@material-ui/core/Grid";

function PrescCard(props) {
  const deleteRecipe = () => {
    console.log(`/removePrescription/${props.presc.documentId}`);
    axios
      .get(`/removePrescription/${props.presc.documentId}`)
      .then((res) => {
        console.log(res.data);
      window.location.reload();

      })
      .catch((err) => {
        console.log(err);
      });

  };

  return (
    <div
      className="shadow" style={{ backgroundColor: "#f2f2f2", borderRadius: 8, marginBottom: 16 }}
    >
      <h3
        style={{
          backgroundColor: "#3f51b5",
          color: "white",
          padding: 8,
          borderTopRightRadius: 8,
          borderTopLeftRadius: 8,
          margin: 0,
        }}
      >
        {props.presc.name}
      </h3>
      <Grid container style={{ flex: 1 }}>
        <Grid style={{ flex: 3 }}>
          <h3
            style={{
              padding: 14,
              borderBottomRightRadius: 8,
              borderBottomLeftRadius: 8,
              margin: 0,
              fontWeight: "normal",
            }}
          >
            <b>Dosing:</b> Take every <b>{props.presc.dosing}</b> hours
        </h3>
        </Grid>
        <Grid style={{ flex: 1, margin: "auto"}}>
          <Button variant="contained" color="secondary" onClick={deleteRecipe}>
            Remove
        </Button>
        </Grid>
      </Grid>

    </div>
  );
}

export default PrescCard;
